import React from 'react';
import ArrModal from '../../../../common/arr-modal/ArrModal';
import ArrButton from '../../../../common/arr-button/ArrButton';
import {Trans, useTranslation} from 'react-i18next';
import {Typography} from '@mui/material';

interface NoRulesAddedWarningProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
}

export const NoRulesAddedWarning: React.FC<NoRulesAddedWarningProps> = ({
  isOpen,
  onClose,
  onProceed,
}) => {
  const {t} = useTranslation();
  if (!isOpen) return null;

  const modalFooter = (
    <div
      className="arr-placeholder-for-priv-docs-modal-footer"
      data-testid={`no-rules-added-warning-cancel-proceed`}>
      <ArrButton
        size="large"
        variant="secondary"
        onClick={onClose}
        dataTestId="no-rules-added-warning-cancel-button"
      >
        {t(
          'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.cancel'
        )}
      </ArrButton>
      <ArrButton
        size="large"
        variant="primary"
        onClick={() => {
          onProceed();
          onClose();
        }}
        dataTestId="no-rules-added-warning-proceed-button"
      >
        {t(
          'productionsAndExports.createNewProduction.privGuard.validationOnNext.placeholderForPrivilegDocsModal.proceed'
        )}
      </ArrButton>
    </div>
  );

  return (
    <ArrModal
      headerTitle={t(
        'productionsAndExports.createNewProduction.privGuard.validationOnNext.noRulesWarningModal.title'
      )}
      headerTitleClassName="headline3_size text-headings"
      showModal={isOpen}
      onClose={onClose}
      footer={modalFooter}
      dataTestId="norulesaddedwarning-modal"
    >
      <Typography
        component="div"
        className="typo-text body2_size desc-text-color"
        color="white"
        data-testid={`assignment-instructions`}
      >
        <Trans
          i18nKey="productionsAndExports.createNewProduction.privGuard.validationOnNext.noRulesWarningModal.content"
          components={{
            br: <br data-testid={`no-rules-added-warning-br`} />,
            strong: <strong data-testid={`no-rules-added-warning-strong`} />,
            p: <p data-testid={`no-rules-added-warning-p`} />,
          }}
        />
      </Typography>
    </ArrModal>
  );
};
